(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["men-mega-menu-mobile"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMenMobileMenu() {
      var root = document.querySelector('[data-men-mobile-menu]');
      if (!root) return;

      var togglers = document.querySelectorAll('.men-mega-menu-toggler');
      var overlay = root.querySelector('[data-mobile-menu-overlay]');
      var closeBtns = root.querySelectorAll('[data-mobile-menu-close]');
      var drillBtns = root.querySelectorAll('[data-mobile-drill]');
      var backBtns = root.querySelectorAll('[data-mobile-back]');
      var layers = root.querySelectorAll('[data-mobile-layer]');
      var accordionTriggers = root.querySelectorAll('[data-accordion-trigger]');

      function getLayer(name) {
        return root.querySelector('[data-mobile-layer="' + name + '"]');
      }

      function openMenu() {
        root.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function closeMenu() {
        root.classList.remove('is-open');
        document.body.style.overflow = '';
        // Reset to root layer after the close transition finishes.
        setTimeout(function () {
          layers.forEach(function (layer) {
            layer.classList.remove('is-active', 'is-prev');
          });
          getLayer('root').classList.add('is-active');
        }, 300);
      }

      function goToLayer(name) {
        var target = getLayer(name);
        if (!target) return;
        var current = root.querySelector('.men-mobile-menu__layer.is-active');
        if (current) {
          current.classList.remove('is-active');
          current.classList.add('is-prev');
        }
        target.classList.add('is-active');
        target.classList.remove('is-prev');
      }

      function goBack() {
        var current = root.querySelector('.men-mobile-menu__layer.is-active');
        var rootLayer = getLayer('root');
        if (current && current !== rootLayer) {
          current.classList.remove('is-active');
        }
        rootLayer.classList.add('is-active');
        rootLayer.classList.remove('is-prev');
      }

      togglers.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
          e.preventDefault();
          openMenu();
        });
      });

      if (overlay) overlay.addEventListener('click', closeMenu);
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', closeMenu);
      });

      drillBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          goToLayer(btn.getAttribute('data-mobile-drill'));
        });
      });

      backBtns.forEach(function (btn) {
        btn.addEventListener('click', goBack);
      });

      accordionTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var accordion = trigger.closest('.men-mobile-menu__accordion');
          if (accordion) accordion.classList.toggle('is-open');
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) {
          closeMenu();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMenMobileMenu);
    } else {
      initMenMobileMenu();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["men-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMenMegaMenu() {
      var menu = document.querySelector('[data-men-mega-menu]');
      if (!menu) return;
      
      var togglers = document.querySelectorAll('.men-mega-menu-toggler');
      var tabs = menu.querySelectorAll('[data-mega-tab]');
      var panels = menu.querySelectorAll('[data-mega-panel]');
      var closeTimeout;
      
      function openMenu() {
        var header = document.querySelector('.homepage .header-wrapper');
        clearTimeout(closeTimeout);
        menu.classList.add('is-open');
        header.style.setProperty('background', 'white');
        console.log(header);
      }
      
      function closeMenu() {
        var header = document.querySelector('.homepage .header-wrapper');
        closeTimeout = setTimeout(function () {
          menu.classList.remove('is-open');
          header.style.removeProperty('background');
        }, 120);
      }

      function activateTab(tabName) {
        tabs.forEach(function (tab) {
          var isActive = tab.getAttribute('data-mega-tab') === tabName;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-mega-panel') === tabName
          );
        });
      }

      togglers.forEach(function (toggler) {
        toggler.addEventListener('mouseenter', openMenu);
        toggler.addEventListener('focus', openMenu);
      });

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);

      togglers.forEach(function (toggler) {
        toggler.addEventListener('mouseleave', closeMenu);
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('mouseenter', function () {
          activateTab(tab.getAttribute('data-mega-tab'));
        });
        tab.addEventListener('click', function () {
          activateTab(tab.getAttribute('data-mega-tab'));
        });
        tab.addEventListener('focus', function () {
          activateTab(tab.getAttribute('data-mega-tab'));
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          menu.classList.remove('is-open');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMenMegaMenu);
    } else {
      initMenMegaMenu();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
